var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "d-flex w-100" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-column", attrs: { id: "neworders" } },
      [
        _vm._m(0),
        _c("div", { staticClass: "flex-grow-1 overflow-hidden d-flex" }, [
          _c(
            "div",
            { staticClass: "card card-no-margin" },
            [
              _c("h4", [_vm._v(_vm._s(_vm.forms_total) + " Questionnaires")]),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-end align-items-start mb-3",
                  staticStyle: { "margin-top": "-60px" }
                },
                [
                  _c("m-form-select", {
                    attrs: {
                      width: 300,
                      label: "Filtrer par type",
                      "label-position": "top",
                      name: _vm.$Utils.randomstring("filterType"),
                      items: _vm.$store.state.items_ed_types
                    },
                    on: { input: _vm.loadForms },
                    model: {
                      value: _vm.filterType,
                      callback: function($$v) {
                        _vm.filterType = $$v
                      },
                      expression: "filterType"
                    }
                  }),
                  _c("m-form-text", {
                    staticClass: "ml-3",
                    attrs: {
                      label: "Rechercher",
                      "label-position": "top",
                      name: "search",
                      autocomplete: ""
                    },
                    on: { input: _vm.loadForms },
                    model: {
                      value: _vm.filterText,
                      callback: function($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText"
                    }
                  })
                ],
                1
              ),
              _c("m-list", {
                ref: "orderslist",
                attrs: {
                  dynamic: true,
                  items: _vm.orders,
                  "item-value": "or_id",
                  "item-height": 30,
                  limit: _vm.forms_limit,
                  skip: _vm.forms_skip,
                  total: _vm.forms_total,
                  bgstrip: true
                },
                on: {
                  changerange: _vm.formsChangeRange,
                  itemclick: _vm.editForm
                },
                scopedSlots: _vm._u([
                  {
                    key: "ths",
                    fn: function(ref) {
                      return [
                        _c("th", { staticStyle: { width: "40px" } }, [
                          _vm._v(" # ")
                        ]),
                        _c("th", [
                          _c("span", { staticClass: "pointer" }, [
                            _vm._v("Contact")
                          ])
                        ]),
                        _c("th", [
                          _c("span", { staticClass: "pointer" }, [
                            _vm._v("Bénéficiaire")
                          ])
                        ]),
                        _c("th", [
                          _c("span", { staticClass: "pointer" }, [
                            _vm._v("Questionnaire")
                          ])
                        ]),
                        _c("th", [
                          _c("span", { staticClass: "pointer" }, [
                            _vm._v("Mis à jour le")
                          ])
                        ])
                      ]
                    }
                  },
                  {
                    key: "tds",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("td", { staticStyle: { width: "40px" } }, [
                          _vm._v(" " + _vm._s(item.no_id) + " ")
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(item.co_id.co_invoice_firstname) +
                              " " +
                              _vm._s(item.co_id.co_invoice_name) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.en_id ? item.en_id.en_fullname : "---"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [_vm._v(" " + _vm._s(item.ed_label) + " ")]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm
                                  .$moment(item.updatedAt)
                                  .format("DD/MM/YYYY HH[H]mm")
                              ) +
                              " "
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("form-win-edit", {
                attrs: { row_ed_p: _vm.itemSelected },
                on: { reload: _vm.loadForms },
                model: {
                  value: _vm.dialog,
                  callback: function($$v) {
                    _vm.dialog = $$v
                  },
                  expression: "dialog"
                }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "row header-emotivi mb-3 justify-content-around align-items-end"
      },
      [
        _c("div", { staticClass: "col" }, [
          _c("h1", [_vm._v("Questionnaires")])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }